import { useState, useEffect, useRef , useCallback} from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findRepresentante from '../../service/findRepresentante';
import { Button } from 'primereact/button';
import { SortOrder } from 'primereact/api';
import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Nullable } from 'primereact/ts-helpers';
import { Toolbar } from 'primereact/toolbar';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import findRepresentanteClienteComissao from '../../service/findRepresentanteClienteComissao';
import putRepresentanteClienteComissao from '../../service/putRepresentanteClienteComissao';


export default function RepresentanteList({ onEdit }: { onEdit: (representante: any) => void }) {
  const { t } = useTranslation();
  const [representantes, setRepresentantes] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const [nome, setNome] = useState<Nullable<String | null>>(null);
  const [documento, setDocumento] = useState<Nullable<String | null>>(null);
  const { state } = useGlobalState();
  const toast = useRef<Toast>(null);
  const [comissoes, setComissoes] = useState<any[]>([]);
  const [showComissaoDialog, setShowComissaoDialog] = useState(false);

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    nome: nome,
    documento: documento,
    idFranquia: state.user.franquiaSelected?.id,
    sortField: 'nome',
    sortOrder: SortOrder.DESC
  });

  const changeDocumento = (doc: Nullable<String>) => {
    if (doc) {
      doc = doc ? doc.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '') : null
      setDocumento(doc);
      setlazyState({
        ...lazyState,
        documento: doc,
        first: lazyState.first,
        page: (lazyState.first / lazyState.rows) + 1
      });
    }
  }

  const changeNome = (value: Nullable<String>) => {
    if (value) {
      setNome(value);
      setlazyState({
        ...lazyState,
        nome: value,
        first: lazyState.first,
        page: (lazyState.first / lazyState.rows) + 1
      });
    }
  }

  const handleDocumento = (event: any) => {
    event.target.value = maskCpfCnpj(event.target.value)
  }

  const cnpj = (v: string) => {
    v = v.replace(/\D/g, "")
    v = v.replace(/^(\d{2})(\d)/, "$1.$2")
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2")
    v = v.replace(/(\d{4})(\d)/, "$1-$2")
    return v
  }

  const cpf = (v: string) => {
    v = v.replace(/\D/g, "")
    v = v.replace(/(\d{3})(\d)/, "$1.$2")
    v = v.replace(/(\d{3})(\d)/, "$1.$2")
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    return v
  }

  const maskCpfCnpj = (input: string) => {
    if (input.length > 14) {
      return cnpj(input)
    }
    else {
      return cpf(input)
    }
  }

  const cols = [
    { field: 'documento', header: 'Documento' },
    { field: 'nome', header: 'Nome' },
    { field: 'cidade', header: 'Cidade' },
    { field: 'inativo', header: 'Inativo' }
  ];
  const exportColumns = cols.map((col) => ({ title: col.header, dataKey: col.field }));

  const exportPdf = () => {
    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then(() => {
        const lazy = { ...lazyState, first: 0, rows: totalRecords, page: 1, inativo: null }
        findRepresentante(lazy).then(data => {
          const doc: any = new jsPDF.default('portrait');
          doc.autoTable(exportColumns, data.representantes);
          doc.save('representantes.pdf');
        });
      });
    });
  };

  const exportExcel = () => {
    import('xlsx').then((xlsx) => {
      const lazy = { ...lazyState, first: 0, rows: totalRecords, page: 1, inativo: null }
      findRepresentante(lazy).then(data => {
        const rows: any[] = []
        data.representantes.forEach((r: any) => rows.push({ nome: r.nome, documento: r.documento, cidade: r.cidade, uf: r.uf, inativo: r.inativo }))

        const worksheet = xlsx.utils.json_to_sheet(rows);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
        saveAsExcelFile(excelBuffer, 'representantes');
      });
    });
  };

  const saveAsExcelFile = (excelBuffer: any, fileName: string) => {
    import('file-saver').then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([excelBuffer], {
          type: EXCEL_TYPE
        });

        module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }
    });
  };

  const header = (
    <div className="flex-consulta align-items-center justify-content-end gap-2">
      <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
      <Button type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={exportPdf} data-pr-tooltip="PDF" />
    </div>
  );

  const onPage = (event: any) => {
    setlazyState({
      ...lazyState,
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const onSort = (event: any) => {
    setlazyState({
      ...lazyState,
      first: 0,
      rows: 10,
      page: 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const loadLazyData = useCallback(() => {
    findRepresentante(lazyState).then(data => {
      setTotalRecords(data.total);
      
      setRepresentantes(data.representantes);
    }).catch(() => { setTotalRecords(0); setRepresentantes(undefined) });
  }, [lazyState])

  const openComissaoDialog = (representante: any) => {
    findRepresentanteClienteComissao(representante.id)
      .then((data) => { setComissoes(data); setShowComissaoDialog(true); })
      .catch(() => { toast.current!.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao buscar comissões', life: 3000 }); });
  };

  const changePercentualComissao = (id: string, value: number | null) => {
    setComissoes((prev) => prev.map((c) => c.id === id ? { ...c, percentualComissao: value } : c));
  };

  const saveComissao = (comissao: any) => {
    putRepresentanteClienteComissao(comissao)
      .then(() => { toast.current!.show({ severity: 'success', summary: 'Sucesso', detail: 'Comissão alterada com sucesso', life: 3000 }); })
      .catch(() => { toast.current!.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao alterar comissão', life: 3000 }); });
  };

  const comissaoDataBodyTemplate = (comissao: any) => {
    if (comissao.data) {
      const date = new Date(comissao.data);
      return date.toLocaleDateString('pt-BR');
    }
    return '-';
  };

  const comissaoPercentualBodyTemplate = (comissao: any) => {
    if (state.user.funcoes.includes('REPRESENTANTE_CLIENTE_COMISSAO_CADASTRAR')) {
      return (
        <div className="flex-consulta align-items-center gap-2">
          <InputNumber value={comissao.percentualComissao} onValueChange={(e) => changePercentualComissao(comissao.id, e.value ?? null)}
            mode="decimal" minFractionDigits={2} maxFractionDigits={2} min={0} max={100} suffix=" %" locale="pt-BR" />
          <Button icon="pi pi-check" onClick={() => saveComissao(comissao)} tooltip="Salvar" style={{ background: 'transparent', color: 'gray', border: 'none' }} />
        </div>
      );
    }
    return comissao.percentualComissao != null ? Number(comissao.percentualComissao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' %' : '-';
  };

  const actionBodyTemplate = (representante: any) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" onClick={() => onEdit(representante)} style={{ background: 'transparent', color: 'gray', border: 'none' }} />
        {state.user.funcoes.includes('REPRESENTANTE_CLIENTE_COMISSAO_VISUALIZAR') && <Button icon="pi pi-percentage" onClick={() => openComissaoDialog(representante)} tooltip="Comissões" style={{ background: 'transparent', color: 'gray', border: 'none' }} />}
      </React.Fragment>
    );
  };

  const startContent = (
    <React.Fragment>
      <div style={{ background: 'transparent' }}>
        <div className="grid">

          <div className="col p-fluid flex flex-wrap">
            <div>
              <div className="flex-auto">
                <label htmlFor="nome" className="font-bold block mb-2">{t('nome')} </label>
                <InputText id="nome" onBlur={(e) => changeNome(e.target.value)} style={{ width: '20rem' }} required></InputText>
              </div>
            </div>
          </div>

          <div className="col p-fluid flex flex-wrap">
            <div>
              <div className="flex-auto">
                <label htmlFor="documento" className="font-bold block mb-2">{t('documento')} </label>
                <InputText id="documento" maxLength={18} max={18} onKeyUp={handleDocumento} onBlur={(e) => changeDocumento(e.target.value)} style={{ width: '20rem' }}></InputText>
              </div>
            </div>
          </div>

        </div>
      </div>
    </React.Fragment>
  );

  useEffect(() => {
    loadLazyData();
  }, [lazyState, loadLazyData])

  return (
    <div>
      <Toast ref={toast} />
      <div>
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <DataTable value={representantes} first={lazyState.first} dataKey="id" paginator={true} lazy={true}
          emptyMessage="Sem registros" header={header}
          onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
          rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
          rowClassName={(data) => data.inativo ? 'inactive-row' : ''}
          tableStyle={{ minWidth: '75rem' }}>
          <Column field="documento" sortable header={t('documento')} />
          <Column field="nome" sortable header={t('nome')} />
          <Column field="cidade" sortable header={t('cidade')} />
          <Column field="uf" sortable header={t('uf')} />
          <Column body={actionBodyTemplate} />
        </DataTable>
        <Dialog header="Comissões" visible={showComissaoDialog} style={{ width: '50rem' }} onHide={() => setShowComissaoDialog(false)}>
          <DataTable value={comissoes} dataKey="id" emptyMessage="Sem registros">
            <Column field="nomeCliente" header="Cliente" />
            <Column body={comissaoPercentualBodyTemplate} header="Percentual" />
            <Column body={comissaoDataBodyTemplate} header="Data" />
          </DataTable>
        </Dialog>
      </div>
    </div>
  )
}
